import { useEffect, useState } from 'react';

/**
 * Возвращает `true` после первого idle-периода браузера (requestIdleCallback).
 *
 * Используется для отложенной инициализации некритичных компонентов:
 * виджеты, чаты, аналитика и любые модули, не нужные при первой отрисовке.
 *
 * На SSR всегда возвращает `false` (useEffect не запускается на сервере).
 *
 * @kind {action}
 * @returns boolean
 */
export function useDeferred(): boolean {
    const [ready, setReady] = useState(false);

    useEffect(() => {
        if ('requestIdleCallback' in window) {
            const id = requestIdleCallback(() => setReady(true));

            return () => cancelIdleCallback(id);
        }

        const id = setTimeout(() => setReady(true), 0);

        return () => clearTimeout(id);
    }, []);

    return ready;
}
